import { render, staticRenderFns } from "./searchModel.vue?vue&type=template&id=2af16d56&scoped=true"
import script from "./searchModel.vue?vue&type=script&lang=js"
export * from "./searchModel.vue?vue&type=script&lang=js"
import style0 from "./searchModel.vue?vue&type=style&index=0&id=2af16d56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af16d56",
  null
  
)

export default component.exports